import { GeojsonFeature } from 'types/GeojsonFeature'
import React from 'react'
import { indexedMunicipalityFeatures } from 'lib/geoFeatures'

interface ActiveMunicipalityPathProps {
  activeMunicipality: string
  strokeColor?: string
  pathGenerator: (feat: GeojsonFeature) => string
}

export const ActiveMunicipalityPath = ({
  activeMunicipality,
  strokeColor = '#CCC',
  pathGenerator
}: ActiveMunicipalityPathProps) => {
  let feature = indexedMunicipalityFeatures.get(activeMunicipality)

  return (
    <path
      d={pathGenerator(feature as GeojsonFeature)}
      strokeWidth={2}
      vectorEffect='non-scaling-stroke'
      stroke={strokeColor}
      strokeLinecap='round'
      strokeLinejoin='round'
      fill='transparent'
      filter='url(#shadow)'
    />
  )
}
